import type { QueryClient } from "@tanstack/react-query";
import type { AnyRouter } from "@tanstack/react-router";

/** Marks widget/tool reads; app-wide reads such as sidebar invitations stay unmarked. */
export const HOME_WIDGET_QUERY_META = { cancelOnHomeLeave: true } as const;

export function cancelHomeWidgetQueries(client: QueryClient) {
  // Cancellation reverts an in-flight refresh to its last successful value.
  // Keep the cache: returning home should reuse it, and destination pages may
  // read the same QR/admin query immediately after this cancellation.
  return client.cancelQueries({
    predicate: (query) => query.meta?.cancelOnHomeLeave === true,
  });
}

export function subscribeToHomeNavigation(
  router: Pick<AnyRouter, "subscribe">,
  client: QueryClient,
) {
  return router.subscribe("onBeforeNavigate", ({ fromLocation, pathChanged }) => {
    if (fromLocation?.pathname === "/" && pathChanged) {
      // The old screen remains mounted while the next route authenticates.
      // Waiting for unmount can leave that request queued behind widget fetches.
      void cancelHomeWidgetQueries(client);
    }
  });
}
